import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sliceLoop',
  pure: true,
  standalone:true
})
export class SliceLoopPipe implements PipeTransform {

  transform(value: any, cutlength: number, activeFilter: string, onFilter: string): unknown {


    if (activeFilter === onFilter) {
      return value
    }
    else {

      return value.slice(0, cutlength)

    }
  }

}
